<template>
  <div>
    <v-row justify="space-between" align="center">
      <v-col cols="12" md="4">
        <v-text-field
          v-model="filter.q"
          placeholder="Cari kode atau index surat"
          prepend-icon="mdi-magnify"
          clearable
        ></v-text-field>
      </v-col>
      <div class="px-5">
        <v-checkbox
          v-if="hasPrivateAccess"
          v-model="filter.no_attachment"
          color="red"
          label="Tanpa Arsip"
        ></v-checkbox>
      </div>
    </v-row>
    <v-row align="center">
      <v-col cols="12" md="6" lg="4" xl="2">
        <v-text-field
          v-model="filter.no"
          placeholder="Nomor Surat"
          prepend-icon="mdi-numeric"
          clearable
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="6" lg="4" xl="2">
        <v-text-field
          v-model="filter.pengirim"
          placeholder="Pengirim"
          prepend-icon="mdi-account-box"
          clearable
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="6" lg="4" xl="2">
        <v-text-field
          v-model="filter.perihal"
          placeholder="Perihal"
          prepend-icon="mdi-help-circle-outline"
          clearable
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="6" lg="4" xl="2" v-if="hasPrivateAccess">
        <v-autocomplete
          prepend-icon="mdi-account"
          label="Tujuan/Tembusan"
          v-model="filter.pengolah_id"
          item-value="id"
          item-text="name"
          :items="$store.state.pejabats"
          clearable
          :menu-props="{ closeOnContentClick: true }"
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" md="6" lg="4" xl="2">
        <v-select
          :items="$store.state.jenisSurat"
          prepend-icon="mdi-book"
          placeholder="Jenis Surat"
          v-model="filter.jenis_surat_id"
          item-value="id"
          item-text="code"
          :menu-props="{ closeOnContentClick: true }"
          clearable
        ></v-select>
      </v-col>
      <v-col cols="12" md="6" lg="4" xl="2">
        <datepicker
          v-model="filter.dates"
          range
          placeholder="Tanggal Masuk Surat"
          :shortcuts="datePickerShortcut"
          format="DD/MM/YYYY"
        />
      </v-col>
    </v-row>
    <v-divider></v-divider>
    <v-data-table
      :headers="headers"
      :items="items"
      item-key="id"
      :sort-by.sync="filter.order_by"
      :sort-desc.sync="filter.sort_desc"
      :loading="loading"
      hide-default-footer
      class="table-row"
      @click:row="onViewSurat"
    >
      <template v-slot:[`item.tgl_masuk`]="{ item }">
        <div class="oflow">
          {{ item.tgl_masuk | date }}
        </div>
      </template>
      <template v-slot:[`item.klasifikasi.jenis`]="{ item }">
        <div class="oflow">
          {{ item.klasifikasi && item.klasifikasi.jenis ? item.klasifikasi.jenis : '-' }}
        </div>
      </template>
      <template v-slot:[`item.tgl_surat`]="{ item }">
        <div class="oflow">
          {{ item.tgl_surat | date }}
        </div>
      </template>
      <template v-slot:[`item.tujuan`]="{ item }">
        <div class="oflow">
          {{ getTujuan(item) }}
        </div>
      </template>
      <template v-slot:[`item.tembusan`]="{ item }">
        <div class="oflow">
          {{
            item.tembusan.length
              ? item.tembusan.map(tb => tb.name).join(', ')
              : '-'
          }}
        </div>
      </template>
      <template v-slot:[`item.note`]="{ item }" style="margin: 0 -5px;">
        <v-chip small color="info" outlined>
          #{{ item.jenis_surat.toLowerCase() }}
        </v-chip>
        <v-chip
          small
          :color="item.is_tembusan ? 'default' : 'success'"
          outlined
        >
          {{ item.is_tembusan ? 'Tembusan' : 'Asli' }}
        </v-chip>
        <v-tooltip bottom v-if="!item.lampiran">
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" color="error">
              mdi-file-remove
            </v-icon>
          </template>
          <span>Arsip belum diupload</span>
        </v-tooltip>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <div class="row-column">
          <v-menu bottom offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                rounded
                small
                color="primary"
                text
                @click.native.stop
              >
                <v-icon>mdi-printer</v-icon>
                <v-icon right dark>mdi-chevron-down</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="onViewReceipt(item)" dense>
                <v-list-item-title>
                  <v-icon small>mdi-receipt</v-icon>
                  Tanda Terima
                </v-list-item-title>
              </v-list-item>
              <v-list-item
                dense
                v-if="item.lampiran"
                @click="viewArsip(item.lampiran)"
              >
                <v-list-item-title>
                  <v-icon small>mdi-file</v-icon>
                  Arsip Surat
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                icon
                light
                @click.stop="onEditItem(item)"
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </template>
            <span>Edit</span>
          </v-tooltip>
          <v-tooltip bottom v-if="isSuperAdmin">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                icon
                light
                color="error"
                @click.stop="onDeleteBtnPressed(item)"
              >
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </template>
            <span>Hapus Surat</span>
          </v-tooltip>
        </div>
      </template>
    </v-data-table>
    <br />
    <v-pagination
      v-model="pagination.current_page"
      :length="pagination.last_page"
      :total-visible="7"
    ></v-pagination>
    <v-dialog
      v-model="viewDialogVisible"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <view-surat
        ref="viewSurat"
        :id-jenis-form="1"
        :item="selectedItem"
        @close-view-form="viewDialogVisible = false"
        @disposisi="showDialogDisposisi"
      />
    </v-dialog>
    <DialogDisposisi
      v-if="$store.state.user.target_disposisi.length"
      ref="dialogDisposisi"
      @success="disposisiSuccess"
      @failed="disposisiFailed"
    />
    <v-dialog
      v-model="deleteDialogVisible"
      transition="dialog-bottom-transition"
      max-width="350"
    >
      <v-card>
        <v-card-title class="headline">
          Yakin Hapus Surat Masuk?
        </v-card-title>

        <v-card-text>
          <table class="delete-table">
            <tr>
              <td>No. Surat</td>
              <th>: {{ deleteSurat.no }}</th>
            </tr>
            <tr>
              <td>Pengirim</td>
              <th>: {{ deleteSurat.pengirim }}</th>
            </tr>
            <tr>
              <td>Perihal</td>
              <th>: {{ deleteSurat.perihal }}</th>
            </tr>
          </table>

          <v-alert text dense color="warning">
            Data surat tidak dapat dikembalikan setelah dihapus
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="grey darken-1"
            text
            @click="deleteDialogVisible = false"
            :disabled="deleting"
          >
            Tidak
          </v-btn>

          <v-btn
            color="red darken-1"
            text
            @click="onDeleteConfirmed"
            :loading="deleting"
          >
            Ya, Hapus
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {
  headerSuratMasuk,
  fetchSuratMasuk,
  deleteSuratMasuk
} from '@/services/surat'
import * as utilscom from '@/utils/common'
import ViewSurat from '@/components/ViewSurat.vue'
import { debounce } from 'lodash'
import { monthNames } from '@/utils/common'
import { mapGetters } from 'vuex'
import { shortcut } from '@/utils/date-picker'
import moment from 'moment'
import DialogDisposisi from './DialogDisposisi.vue'

export default {
  name: 'surat-masuk-list',
  components: {
    'view-surat': ViewSurat,
    DialogDisposisi
  },
  data() {
    return {
      disposisiVisible: false,
      viewDialogVisible: false,
      loading: false,
      months: monthNames.map((month, index) => ({
        value: index + 1,
        text: month
      })),
      items: [],
      selectedItem: {},
      isEdit: false,
      pagination: {
        current_page: 1,
        per_page: 10,
        total: 0,
        last_page: 0,
        from: 1
      },
      filter: {
        no_attachment: false,
        q: '',
        dates: [],
        order_by: ['index_surat'],
        sort_desc: [true],
        pengolah_id: null,
        pengirim: '',
        perihal: '',
        no: '',
        jenis_surat_id: null
      },
      deleteDialogVisible: false,
      deleteSurat: {},
      deleting: false,
      datePickerShortcut: shortcut
    }
  },
  watch: {
    currentPage: function(val) {
      this.loadData(val)
    },
    filter: {
      handler: debounce(function() {
        this.loadData(1)
      }, 500),
      deep: true
    }
  },
  mounted() {
    this.loadData(1)
  },
  computed: {
    ...mapGetters(['hasPrivateAccess', 'isSuperAdmin']),
    currentPage() {
      return this.pagination.current_page
    },
    headers() {
      if (!this.hasPrivateAccess) {
        return headerSuratMasuk.filter(header => header.value !== 'actions')
      }
      return headerSuratMasuk
    }
  },
  methods: {
    getTujuan(item) {
      let tujuan = item.tujuan.map(tj => tj.name)
      if (item.tujuan_lain) {
        tujuan.push(item.tujuan_lain)
      }
      if (tujuan.length) {
        return tujuan.join(', ')
      }
      return '-'
    },
    async loadData(page = this.pagination.current_page) {
      this.loading = true
      try {
        const {
          no_attachment,
          order_by,
          sort_desc,
          dates,
          ...filter
        } = this.filter
        let params = {
          ...filter,
          page,
          per_page: this.pagination.per_page
        }
        if (dates.length && dates[0]) {
          params.from = moment(dates[0]).format('YYYY-MM-DD')
          params.to = moment(dates[1]).format('YYYY-MM-DD')
        }
        if (order_by.length) {
          params.order_by = order_by[0]
        }
        if (sort_desc.length) {
          params.sort = sort_desc[0] ? 'desc' : 'asc'
        }
        if (no_attachment) {
          params.no_attachment = true
        }
        const { data, pagination } = await fetchSuratMasuk(params)
        this.items = data
        this.pagination = pagination
      } catch (error) {
        // console.log('load surat masuk error', error)
      } finally {
        this.loading = false
      }
    },
    getItemOrderNumber(item) {
      const index = this.items.findIndex(i => i.id === item.id)
      return this.pagination.from + index
    },
    onEditItem(item) {
      item.selectedItemTableIndex = this.items.indexOf(item)
      this.isEdit = true
      this.$emit('edit-surat', item)
    },
    onDeleteBtnPressed(item) {
      this.deleteDialogVisible = true
      this.deleteSurat = item
    },
    async onDeleteConfirmed() {
      this.deleting = true
      try {
        await deleteSuratMasuk(this.deleteSurat.id)
        this.deleteDialogVisible = false
        this.deleting = false
        this.deleteSurat = {}
        this.$emit('handle-snackbar', 'Surat masuk telah dihapus', 'success')
        this.loadData(this.pagination.current_page)
      } catch (error) {
        this.deleting = false
        this.$emit('handle-snackbar', error.message, 'error')
      }
    },
    onViewReceipt(item) {
      this.isEdit = true
      utilscom.createTandaTerima(item)
    },
    onViewSurat(item) {
      if (!this.isEdit) {
        this.selectedItem = item
        this.viewDialogVisible = true
      }
      this.isEdit = false
    },
    viewArsip(url) {
      window.open(url, '_blank')
    },
    showDialogDisposisi(id) {
      this.$refs.dialogDisposisi.show(id)
    },
    disposisiSuccess(surat) {
      const index = this.items.findIndex(i => i.id === surat.id)

      console.log('diposisi success', { index, surat })

      this.items[index] = surat
      this.selectedItem = surat
      this.$emit('handle-snackbar', 'Disposisi Berhasil Dikirim')
    },
    disposisiFailed(error) {
      this.$emit('handle-snackbar', error, 'error')
    }
  }
}
</script>

<style lang="sass" scoped>
.row-column
  display: flex
  flex-direction: row
  justify-content: flex-end
  align-items: center

.v-chip
  margin-left: 5px
  margin-right: 5px

.bg-warning
  background-color: #FFECB3

.delete-table
  width: 100%
  margin-bottom: 20px
  th
    text-align: left

.mx-datepicker-range
  width: 100%
</style>

<style scoped>
.table-row >>> tbody tr :hover {
  cursor: pointer;
}
</style>
